var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-carousel',_vm._l((_vm.chunks),function(chunk,i){return _c('q-carousel-slide',{key:i},[_c('div',{staticClass:"row gutter-xs"},_vm._l((chunk),function(item,j){return _c('v-card',{key:j,attrs:{"layout":_vm.layout,"item":item,"is-video":_vm.isVideo}})}))])}))}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c647c29a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/front/Carousel.vue
// module id = K5u9
// module chunks = 54